<template>
  <b-card :title="title" class="border-0">
    <b-form method="GET" :action="url" ref="searchForm" class="d-flex justify-content-between">
      <b-form-row style="min-width: 60%;">
        <b-col cols="6" sm="6" md="4" lg="2">
          <b-form-group label="Nómina">
            <b-input-group>
              <b-input-group-prepend class="border-0 rounded-left">
                <b-input-group-text class="bg-white">
                  <b-icon icon="list-ul" style="color: #ff9e18;"></b-icon>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select :options="payrollTypeOptions"
                name="payroll_type"
                :value="payrollType"
                @input="payrollTypeChanged"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="6" sm="6" md="4" lg="2">
          <b-form-group label="Empresa:">
            <b-input-group>
              <b-input-group-prepend class="border-0 rounded-left">
                <b-input-group-text class="bg-white">
                  <b-icon icon="arrow-repeat" animation="spin-pulse" v-if="loadingEnterprises"></b-icon>
                  <b-icon icon="building" style="color: #ff9e18;" v-else></b-icon>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select
                :options="enterpriseOptions"
                name="enterprise"
                :value="enterpriseId"
                @input="enterpriseChanged"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="2" v-if="!noArea">
          <b-form-group label="Área:">
            <b-input-group>
              <b-input-group-prepend class="border-0 rounded-left">
                <b-input-group-text class="bg-white">
                  <b-icon icon="arrow-repeat" animation="spin-pulse" v-if="loadingAreas"></b-icon>
                  <b-icon icon="grid" style="color: #ff9e18;" v-else></b-icon>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select :options="areaOptions"
                name="area"
                :value="areaId"
                @input="areaChanged"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="2" v-if="!noSegment">
          <b-form-group label="Departamento:">
            <b-input-group>
              <b-input-group-prepend class="border-0 rounded-left">
                <b-input-group-text class="bg-white">
                  <b-icon icon="arrow-repeat" animation="spin-pulse" v-if="loadingSegments"></b-icon>
                  <b-icon icon="people" style="color: #ff9e18;" v-else></b-icon>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select :options="segmentOptions"
                name="segment"
                :value="segmentId"
                @input="segmentChanged"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="2" v-if="!noGroup">
          <b-form-group label="Puestos:">
            <b-input-group>
              <b-input-group-prepend class="border-0 rounded-left">
                <b-input-group-text class="bg-white">
                  <b-icon icon="arrow-repeat" animation="spin-pulse" v-if="loadingGroups"></b-icon>
                  <b-icon icon="person" style="color: #ff9e18;" v-else></b-icon>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select :options="groupOptions" 
                name="group" 
                :value="groupId"
                @input="groupChanged"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="2" class="align-self-center">
          <div class="">
            <div v-if="!noDates">
              <payroll-calendar @date-changed="onDateChange" v-model="range" :payroll-type="enterprise && enterprise.payroll_type || null"></payroll-calendar>
            </div>
            <div class="d-flex d-xs-flex d-sm-flex d-md-block align-items-end" v-if="!noDefaultButton && !$slots.actions">
              <b-button
                      v-if="!noDefaultButton"
                      web
                      :disabled="canSubmitPayroll"
                      variant="primary"
                      @click="lazy ? $emit('submit-button-clicked') : $refs.searchForm.submit()"
                      class="btn-block m-1"
              >
                {{ submitButtonText }}
              </b-button>
              <slot name="actions" :range="range">

              </slot>
            </div>
          </div>
        </b-col>
      </b-form-row>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { BIcon, BIconPerson, BIconListUl, BIconArrowRepeat, BIconBuilding, BIconPeople, BIconGrid } from 'bootstrap-vue';
import axios from 'axios';

import PayrollCalendar from '../../PayrollCalendar.vue';

export default {
  props: {
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default: 'Nómina'
    },
    submitButtonText: {
      type: String,
      default: 'Consultar'
    },
    noGroup: {
      type: Boolean,
      default: false
    },
    noSegment: {
      type: Boolean,
      default: false
    },
    noArea: {
      type: Boolean,
      default: false
    },
    noDates: {
      type: Boolean,
      default: false
    },
    noDefaultButton: {
      type: Boolean,
      default: false
    },
    lazy: { // TODO: Choose a better name for this prop
      type: Boolean,
      default: false
    }
  },
  components: {
    PayrollCalendar,
    BIcon, BIconPerson, BIconListUl, BIconArrowRepeat, BIconBuilding, BIconPeople, BIconGrid
  },
  computed: {
    ...mapState({
      date: state => state.payrollClasification.date, 
      end_date: state => state.payrollClasification.end_date, 
      payrollType: state => state.payrollClasification.payrollType,
      enterpriseId: state => state.payrollClasification.enterpriseId,
      areaId: state => state.payrollClasification.areaId,
      segmentId: state => state.payrollClasification.segmentId, 
      groupId: state => state.payrollClasification.groupId, 
      loadingEnterprises: state => state.payrollClasification.loadingEnterprises,
      loadingAreas: state => state.payrollClasification.loadingAreas,
      loadingSegments: state => state.payrollClasification.loadingSegments,
      loadingGroups: state => state.payrollClasification.loadingGroups,
      enterprises: state => state.payrollClasification.enterprises,
      areas: state => state.payrollClasification.areas,
      segments: state => state.payrollClasification.segments,
      groups: state => state.payrollClasification.groups

    }),
    ...mapGetters('payrollClasification', [
      'enterpriseOptions',
      'areaOptions',
      'segmentOptions',
      'groupOptions',
      'enterprise',
      'payrollTypeOptions'
    ]),
    canSubmitPayroll() {
      return this.enterpriseId==null;
    },
    range: {
      get() {
        return {
          start: this.date,
          end: this.end_date
        };
      },
      set(newVal) {
        this.setDate(newVal.start);
        this.setEndDate(newVal.end);
        this.$emit('date-changed', newVal); 
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('payrollClasification/init');
  },
  methods: {
    ...mapMutations('payrollClasification', [
      'setDate',
      'setEndDate',
      'setPayrollType',
      'setEnterpriseId',
      'setAreaId',
      'setSegmentId',
      'setGroupId'
    ]),
    payrollTypeChanged(payrollType) {
      this.setPayrollType(payrollType);
      this.$store.dispatch('payrollClasification/loadEnterprises', { payrollType });
    },
    enterpriseChanged(enterprise) {
      console.log('enterprise changes', enterprise);
      this.setEnterpriseId(enterprise);

      if (enterprise) {

        // this.setDate(this.enterprise.payroll_type.start_date);
        // this.setEndDate(this.enterprise.payroll_type.end_date);
        this.range = {start: this.enterprise.payroll_type.start_date, end: this.enterprise.payroll_type.end_date};
        this.$store.dispatch('payrollClasification/loadAreas', { enterprise });
      }
    },
    areaChanged(area) {
      this.setAreaId(area);
      this.$store.dispatch('payrollClasification/loadSegments', { area });
    },
    segmentChanged(segment) {
      this.setSegmentId(segment);
      this.$store.dispatch('payrollClasification/loadGroups', { segment });
    },
    groupChanged(group) {
      this.setGroupId(group);
    },
    onDateChange(date) {
      this.$emit('date-changed', date);  
    }
  }
}
</script>
